import { Link, Navigate, useParams } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { useSeo } from '@/lib/useSeo';

const cleanSlug = (s) =>
  decodeURIComponent(s || '')
    .toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9-]/g, '');

// Old WordPress permalinks (/2025/08/29/<slug>/) -> new blog URL
export const WpPostRedirect = () => {
  const { year, month, day, slug } = useParams();
  if (!/^\d{4}$/.test(year) || !/^\d{1,2}$/.test(month) || !/^\d{1,2}$/.test(day)) return <NotFoundPage />;
  return <Navigate to={`/blog/${cleanSlug(slug)}`} replace />;
};

// Old WordPress tag / category archives -> blog overview
export const WpArchiveRedirect = () => <Navigate to="/blog" replace />;

export const NotFoundPage = () => {
  useSeo({ title: 'Seite nicht gefunden | Neobroker.com', description: 'Diese Seite existiert nicht (mehr).', noindex: true });
  return (
    <div className="min-h-screen bg-background pt-1" data-testid="not-found-page">
      <Navigation />
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-28 max-w-2xl">
        <p className="text-sm font-medium text-[hsl(210,100%,56%)]">Fehler 404</p>
        <h1 className="mt-2 text-4xl sm:text-5xl font-bold text-foreground">Seite nicht gefunden</h1>
        <p className="mt-4 text-muted-foreground">Diese Seite gibt es nicht (mehr). Vielleicht hilft dir einer dieser Links weiter:</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="px-5 h-11 inline-flex items-center rounded-xl text-white bg-gradient-to-r from-[hsl(210,100%,56%)] to-[hsl(190,95%,55%)]" data-testid="not-found-home-link">Startseite</Link>
          <Link to="/compare" className="px-5 h-11 inline-flex items-center rounded-xl border border-white/20 text-foreground" data-testid="not-found-compare-link">Broker-Vergleich</Link>
          <Link to="/blog" className="px-5 h-11 inline-flex items-center rounded-xl border border-white/20 text-foreground" data-testid="not-found-blog-link">Blog</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};
